import React, { useEffect, useState } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { IState } from 'store';
import { useMiniCart } from 'hooks';
import { ICartProps } from 'store/modules/cart';
import { IConfigProps } from 'store/modules/config';

import Modal from 'components/common/Modal';
import ModalChangeState from 'components/common/Templates/ModalChangeState';
import { BasketWithItems } from 'components/common/Templates/BasketWithItems';

import Search from '../Search';
import MenuMobile from './MenuMobile';

import * as S from './styles';

function HeaderMobile() {
  const router = useRouter();
  const { dropMiniCart, dropped } = useMiniCart();
  const cart = useSelector<IState, ICartProps>(state => state.cart.cart);

  const {
    config,
    uf: ufSelected,
    backgroundColorHeader,
  } = useSelector<IState, IConfigProps>(state => state.config);

  const [location, setLocation] = useState('');
  const [windowWidth, setWindowWidth] = useState('web');
  const [sideMenuDropped, setSideMenuDropped] = useState(false);
  const [showModalChangeState, setShowModalChangeState] = useState(false);

  useEffect(() => {
    setLocation(ufSelected.value);
  }, [ufSelected]);

  function resizeWindow() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 580) {
        setWindowWidth('web');
      } else {
        setWindowWidth('mobile');
      }
    }
  }

  useEffect(() => {
    resizeWindow();

    window.addEventListener('resize', resizeWindow);

    return () => window.removeEventListener('resize', resizeWindow);
  }, []);

  return (
    <>
      <S.Container
        className="header-mobile"
        backgroundColor={backgroundColorHeader}
      >
        <div className="header-background-top">
          <div className="header-top">
            <img
              src="/images/icons/menu-sandwich-white.svg"
              alt="Menu"
              className="icon icon-menu-sandwich"
              onClick={() => setSideMenuDropped(true)}
            />

            <Link href="/" passHref>
              <a className="logo">
                <img
                  loading="lazy"
                  src={
                    config.aparencia?.logo
                      ? config.aparencia.logo
                      : '/images/ultrafarma-sports-nutrition-logo.png'
                  }
                  alt="Ultrafarma Sports Nutrition"
                  className="header-logo"
                />
              </a>
            </Link>

            <Search />

            <div className="header-nav">
              <div
                className="header-nav-shopping"
                onClick={() => {
                  if (!router.asPath.includes('/checkout')) dropMiniCart();

                  if (windowWidth === 'mobile') {
                    router.push('/checkout/carrinho');
                  }
                }}
              >
                <BasketWithItems
                  color="white"
                  quantity={cart.totalItens}
                  style={{ position: 'relative' }}
                />
                <span>{cart.subtotalTexto || 'R$ 0,00'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="header-background-search">
          <Search />

          <div className="home-nav-location">
            <img
              src="/images/icons/location-black.svg"
              alt="Local"
              className="icon location-icon"
            />

            <div>
              <p>Vendo preços para:</p>

              <div
                className="home-nav-location-info"
                onClick={() => setShowModalChangeState(true)}
              >
                <span>{location}</span>

                <span
                  className="chevron-icon down black mb-2"
                  title="Mostrar mais"
                />
              </div>
            </div>
          </div>
        </div>
      </S.Container>

      {sideMenuDropped && (
        <MenuMobile onClose={() => setSideMenuDropped(false)} />
      )}

      {showModalChangeState && (
        <Modal onClose={() => setShowModalChangeState(false)}>
          <ModalChangeState setShowModalChangeState={setShowModalChangeState} />
        </Modal>
      )}
    </>
  );
}

export default HeaderMobile;
